import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "./apiClient";
import type { TestHttpLog } from "@/pages/testing/shared";

/**
 * Test výměny zařízení — admin API `/admin/api/v1/testing/device-replacement/**`.
 * `/start` streamuje SSE (jen `data:` řádky, bez `event:`),
 * workflow create → process (QR sekvence) → complete. Viz [[sse.ts]].
 */

export interface DeviceReplacementRequest {
  tokenId: string;
  message?: string | null;
  autoProcess: boolean;
  simulateQrDelay: boolean;
  qrDelayMs: number;
}

export interface DeviceReplacementResult {
  success: boolean;
  originalTokenId: string;
  newTokenId?: string | null;
  transactionId: string;
  message?: string | null;
  qrSequenceCount?: number | null;
  qrCodes?: string[] | null;
  newActivationGuid?: string | null;
  completedAt: string;
  durationMs: number;
  httpLogs: TestHttpLog[];
  stepsExecuted?: string[] | null;
}

export interface DeviceReplacementProgress {
  status: string;
  message: string;
  timestamp: string;
  step?: number | null;
  totalSteps?: number | null;
  data?: {
    transactionId?: string;
    qrCodes?: string[];
    error?: string;
    stepsExecuted?: string[];
  } & Partial<DeviceReplacementResult>;
}

export interface DeviceReplacementScenario {
  name: string;
  description: string;
  tokenId: string;
  authServerType: string;
  message?: string | null;
  autoProcess: boolean;
  autoComplete: boolean;
  simulateQrDelay: boolean;
}

export function useDeviceReplacementScenarios() {
  return useQuery({
    queryKey: ["test-device-replacement", "scenarios"],
    queryFn: () => apiFetch<DeviceReplacementScenario[]>("/admin/api/v1/testing/device-replacement/scenarios"),
  });
}
